import { render, staticRenderFns } from "./ModalDuplicationMenu.vue?vue&type=template&id=32660f6a&"
import script from "./ModalDuplicationMenu.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32660f6a')) {
      api.createRecord('32660f6a', component.options)
    } else {
      api.reload('32660f6a', component.options)
    }
    module.hot.accept("./ModalDuplicationMenu.vue?vue&type=template&id=32660f6a&", function () {
      api.rerender('32660f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Menus/ModalDuplicationMenu.vue"
export default component.exports